import { useState } from "react";
import { useDispatch } from "react-redux";

import { showNotification } from "jazasoft";

// helper
import useQuery from "../../hooks/useQuery";
import useMutation from "../../hooks/useMutation";
import { isEmpty } from "../../utils/helpers";
import { Role } from "../../utils/types";

const useSettings = props => {
  const { id, roles } = props;
  const [version, setVersion] = useState(1);

  // api call
  const { data: settings = [] } = useQuery({ url: "settings", version });

  const { data: groups = [] } = useQuery({ url: "configs/setting-groups" });

  const setting = !isEmpty(settings) && id && settings.find(e => e.id === id);

  // hooks
  const [mutate] = useMutation();
  const dispatch = useDispatch();

  const updateSetting = (setting, cb) => {
    if (!setting || !setting.key) return;
    const options = {
      url: `settings/${setting.key}`,
      method: "put",
      data: setting
    };
    mutate(options, {
      onSuccess: () => {
        setVersion(version => version + 1);
        dispatch(showNotification("Setting updated successfully."));
        cb && cb();
      },
      onFailure: () => cb && cb()
    });
  };

  return {
    settings,
    setting,
    groups: roles && (roles.includes(Role.MASTER) || roles.includes(Role.SUPER_USER)) ? groups : groups.slice(0, 6),
    updateSetting
  };
};

export default useSettings;
